import { styled } from '@mui/material/styles'
import CheckCircle from '@mui/icons-material/CheckCircle'

export const ClosingReqCheck = styled(CheckCircle, {
  name: 'ClosingReqCheck',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== 'isComplete',
})<{ isComplete: boolean }>(({ theme, isComplete }) => ({
  fontSize: 'small',
  marginRight: theme.spacing(0.7),
  color: isComplete ? '#01579b' : theme.palette.text.disabled,
}))
